import Vue from 'vue'
import store from './store/store'
import Router from 'vue-router'
import login from './views/security/Login'
import farmForm from './views/form/FarmForm'
import animalForm from './views/form/AnimalForm'
import moveAnimalForm from './views/form/MoveFarmForm.vue'
import bullForm from './views/form/BullForm'
import buildingForm from './views/form/BuildingForm'
import milkInspectionForm from './views/form/MilkInspectionForm'
import SicknessForm from './views/form/SicknessForm'
import dashboard from './views/Dashboard'
import cattle from './views/Cattle'
import bull from './views/Bull'
import cattleLog from './views/CattleLog'
import fecondity from './views/Fecondity'
import milkInspection from './views/MilkInspection'
import culled from './views/Culled'
import animalCard from './views/card/AnimalCard'
import triforce from './views/Triforce'
// import farmPwa from './views/pwa/farmList'
import animalPwa from './views/pwa/animalSearch'
import localforage from "localforage"
import farm from "@/views/Farm.vue"
import moveFarmForm from "@/views/form/MoveFarmForm.vue"
import bullCard from "@/views/card/BullCard.vue"

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.API_URL,
    routes: [
        {
            path: '/',
            name: 'security',
            component: login,
            meta: { requiresAuth: false },
        },
        {
            path: '/login',
            redirect: '/'
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: dashboard,
            meta: { requiresAuth: true },
            children: [
                {
                    path: '/new-farm',
                    name: 'new-farm-form',
                    component: farmForm,
                    meta: {requiresAuth: true},
                    // props: true,
                    props: {
                        farmToUpdate: {
                            id: null,
                            name: '',
                            manager: '',
                            address: ''
                        }
                    }
                },
                {
                    path: '/edit-farm',
                    name: 'edit-farm-form',
                    component: farmForm,
                    meta: {requiresAuth: true},
                    props: true
                }
            ]
        },
        {
            path: '/farm/:farmId',
            name: 'farm-summary',
            component: farm,
            meta: { requiresAuth: true },
            props: true
        },
        {
            path: '/cattle/:farmId',
            name: 'cattle',
            component: cattle,
            meta: { requiresAuth: true },
            children: [
                {
                    path: 'new-animal',
                    name: 'new-animal-form',
                    component: animalForm,
                    meta: {requiresAuth: true},
                    props: {
                        animalToUpdate: {
                            id: null,
                            birthday: Math.trunc(Date.now() / 1000),
                            buckleNumber: '',
                            building: null,
                            type: 'heifer',
                            isBought: false,
                            father: null,
                            mother: null,
                            prevalenceSickness: null
                        }
                    }
                },
                {
                    path: 'move-animal/:animalId',
                    name: 'move-animal-form',
                    component: moveAnimalForm,
                    meta: {requiresAuth: true},
                    props: true
                },
                {
                    path: 'edit-animal/:animalId',
                    name: 'edit-animal-form',
                    component: animalForm,
                    meta: {requiresAuth: true},
                    props: true
                },
                {
                    path: 'new-building',
                    name: 'new-building-form',
                    component: buildingForm,
                    meta: {requiresAuth: true},
                    props: {
                        buildingToUpdate: {
                            id: null,
                            farmId: null,
                            name: '',
                            maximumCapacity: 0,
                            type: 'stabling'
                        }
                    }
                },
                {
                    path: 'edit-building/:buildingId',
                    name: 'edit-building-form',
                    component: buildingForm,
                    meta: {requiresAuth: true},
                    props: true
                },
                {
                    path: 'edit-sicknesses/:animalId',
                    name: 'edit-sicknesses-form',
                    component: SicknessForm,
                    meta: {requiresAuth: true},
                    props: true
                }
            ]
        },
        {
            path: '/bulls/:farmId',
            name: 'bulls',
            component: bull,
            meta: { requiresAuth: true },
            children: [
                {
                    path: 'new-bull',
                    name: 'new-bull-form',
                    component: bullForm,
                    meta: {requiresAuth: true},
                    props: {
                        bullToUpdate: {
                            id: null,
                            birthday: Math.trunc(Date.now() / 1000),
                            buckleNumber: '',
                            building: null,
                            type: 'bull',
                            isBought: false,
                            bullRating: {
                                id: null,
                                fertility: null,
                                milkProduction: null,
                                udderHealth: null,
                                sicknessProprensity: null
                            }
                        }
                    }
                },
                {
                    path: 'edit-bull/:animalId',
                    name: 'edit-bull-form',
                    component: bullForm,
                    meta: {requiresAuth: true},
                    props: true
                },
                {
                    path: 'bull-card/:animalId',
                    name: 'bull-card',
                    component: bullCard,
                    meta: {requiresAuth: true},
                    props: true
                }
            ]
        },
        {
            path: '/cattlelog/:farmId',
            name: 'cattle-log',
            component: cattleLog,
            meta: { requiresAuth: true }
        },
        {
            path: '/fecondity/:farmId',
            name: 'fecondity',
            component: fecondity,
            meta: { requiresAuth: true }
        },
        {
            path: '/milkinspection/:farmId',
            name: 'milk-inspection',
            component: milkInspection,
            meta: { requiresAuth: true },
            children: [
                {
                    path: 'new-inspection',
                    name: 'new-inspection-form',
                    component: milkInspectionForm,
                    meta: { requiresAuth: true },
                    props: {
                        milkInspectionToUpdate: {
                            id: null,
                            milkingDate: null,
                            results: []
                        },
                        milkResultsToUpdate: []
                    }
                },
                {
                    path: 'edit-inspection/:inspectionId',
                    name: 'edit-inspection-form',
                    component: milkInspectionForm,
                    meta: { requiresAuth: true },
                    props: true
                }
            ]
        },
        {
            path: '/culled/:farmId',
            name: 'culled',
            component: culled,
            meta: { requiresAuth: true }
        },
        {
            path: '/triforce',
            name: 'triforce',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
                import(/* webpackChunkName: "triforce" */ './views/Triforce.vue')
        },
        {
            path: '/pwa/cattle/:farmId',
            name: 'pwa-animal-search',
            component: animalPwa,
            meta: { requiresAuth: true },
        },
        {
            path: '/pwa/animal-card/:animalId',
            name: 'pwa-animal-card',
            component: animalCard,
            meta: { requiresAuth: true },
            props: true
        }
        // {
        //     path: '/pwa/animals',
        //     name: 'animals-pwa',
        //     component: animalPwa,
        //     meta: { requiresAuth: true }
        // }
    ]
})

const waitForStorageToBeReady = async (to, from, next) => {
    await store.restored
    if (to.name === 'security' || to.name === 'login') {
        next()
    } else if (from.meta.requiresAuth && to.meta.requiresAuth) {
        next()
    } else if ((from.name === 'security' || from.name === 'login') && to.name === 'dashboard') {
        next()
    } else {
        localforage
            .getItem('molokoden')
            .then(response => {
                if (
                    (response.profile.token !== '' &&
                        response.profile.loggedAt !== null &&
                        response.profile.loggedAt + 604800 * 1000 > new Date().getTime()) ||
                    store.state.profile.token !== ''
                ) {
                    next()
                } else {
                    next('/')
                    localforage.clear()
                }
            })
            .catch(error => {
                console.log('error')
                console.log(error)
                // localforage.clear()
                to.meta.requiresAuth ? next('/') : next()
            })
    }
}
router.beforeEach(waitForStorageToBeReady)

export default router
